var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('advanced-table',{ref:"archiveTable",attrs:{"headers":_vm.headers,"filters":_vm.filters,"sortBy":'startDate',"descending":true,"resource":_vm.resource,"optionLists":_vm.optionLists,"customQueryFilter":_vm.generateCustomQueryFilter,"queryExtras":_vm.getRouteQueryExtras}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ba4038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/archive/EventsArchive.vue
// module id = 716
// module chunks = 1